import React from "react";
import { shade } from "polished";
import styled, { css } from "styled-components";
import { Box, Flex } from "rebass";

const Wrapper = styled(Flex)`
  width: 30%;
  min-width: 336px;
  border-width: 0;
  border-color: ${(props) =>
    props.theme.colors.grey[1] && shade(0.875, props.theme.colors.grey[1])};
  /* border-style: solid; */

  &:not(:lang(ar)) {
    width: 30%;
    min-width: 336px;
    order: 1;
    margin-right: 0;
    margin-left: 48px;
    padding-right: 0;
    padding-left: 48px;
    border-left-width: 1px;
    @media only screen and (max-width: 72em) {
      margin-left: 32px;
      padding-left: 32px;
    }
  }
  &:lang(ar) {
    width: 30%;
    min-width: 336px;
    order: -1;
    margin-right: 48px;
    margin-left: 0;
    padding-right: 48px;
    padding-left: 48px;
    border-right-width: 1px;
    @media only screen and (max-width: 72em) {
      margin-right: 32px;
      padding-right: 32px;
    }
  }

  @media only screen and (max-width: 64em) {
    order: 1 !important;
    width: 100% !important;
    min-width: initial !important;
    margin-top: 64px;
    margin-right: 0 !important;
    margin-left: 0 !important;
    padding-right: 0 !important;
    padding-left: 0 !important;
    border-width: 0 !important;
  }

  ${(props) =>
    props.mobileTop &&
    css`
      @media only screen and (max-width: 64em) {
        order: -1 !important;
        margin-top: 0 !important;
        margin-bottom: 48px !important;
      }
    `};
`;

Wrapper.defaultProps = {
  is: "aside",
};

const Container = styled(Box)`
  width: 100%;
`;

Container.defaultProps = {};

const PageSidebar = (props) => (
  <Wrapper mobileTop={props.mobileTop}>
    <Container>{props.children}</Container>
  </Wrapper>
);

PageSidebar.defaultProps = {};

export default PageSidebar;



// WEBPACK FOOTER //
// ./src/components/PageSidebar.js